
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consumer/login",
      function () {
        return require("private-next-pages/consumer/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consumer/login"])
      });
    }
  